const renderStats = (renderOptions, isFirstRender) => {
  const { nbHits, widgetParams } = renderOptions;

  if (isFirstRender) return;

  widgetParams.container.innerHTML = `${nbHits} ${widgetParams.text}${
    nbHits === 1 ? "" : "s"
  }`;
};

export const productCount =
  window.instantsearch.connectors.connectStats(renderStats);
